import { Component, ElementRef, ViewChild, OnDestroy } from "@angular/core";
import { SelectionModel } from '@angular/cdk/collections';
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import {
  MatPaginatorModule,
  MatPaginator,
  PageEvent,
} from "@angular/material/paginator";
import { MatSortModule, MatSort } from "@angular/material/sort";
import { MatTableModule, MatTableDataSource } from "@angular/material/table";
import { TranslateModule } from "@ngx-translate/core";
import { Config } from "../../core/DefaultConfig";
import { DeleteModel } from "../../core/models/dele.model";
import { DeleteDialogComponent } from "../../shared/delete-dialog/delete-dialog.component";
import { AlertDialogComponent } from "../../shared/alert-dialog/alert-dialog.component";

import { Router, RouterModule } from "@angular/router";
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getCustomPaginatorIntl } from "../../shared/paginator.helper";
import { GenericCrudService } from "../../core/services/generic-crud.service";
import { AppUrlConstants } from "../../core/constants/AppUrlConstants";
import { ComplaintStateService, ComplaintListState } from "../../core/services/complaint-state.service";
import { Subject, forkJoin, of } from "rxjs";
import { takeUntil, tap, catchError } from "rxjs/operators";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  MatOptionModule,
  provideNativeDateAdapter,
} from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { ApplicationDataService } from "../../core/services/application-data.service";
import { AuthenticationService } from "../../core/services/authentication.service";
import { TokenStorageService } from "../../core/services/token-storage.service";
import { StripHtmlPipe } from "../../core/pipes/strip-html.pipe";
import { SendEmailDialogComponent } from "./complaint-edit/send-email-dialog/send-email-dialog.component";
import { SendSmsDialogComponent } from "./complaint-edit/send-sms-dialog/send-sms-dialog.component";
import { SendMessageModel } from "../../core/models/send-message.model";
import { CommonModule } from "@angular/common";
import { DropDialogComponent } from "./complaint-edit/drop-dialog/drop-dialog.component";
import { AppealDialogComponent } from "./complaint-edit/appeal-dialog/appeal-dialog.component";
import { ReopenDialogComponent } from "./complaint-edit/reopen-dialog/reopen-dialog.component";
import { MatMenuModule } from "@angular/material/menu";
import { DatePipe } from "@angular/common";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

interface Complaint {
  complaintNo: string;
  status: string;
  cnic: string;
  category: string;
  complainant: string;
  phone: string;
  division: string;
  assignee: string;

}

const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();

@Component({
  selector: "app-complaint",
  standalone: true,
  providers: [
    provideNativeDateAdapter(),
    DatePipe,
    { provide: MatPaginatorIntl, useValue: getCustomPaginatorIntl('Complaints per page') }
  ],

  templateUrl: "./complaint.component.html",
  styleUrl: "./complaint.component.css",
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    TranslateModule,
    RouterModule,
    ReactiveFormsModule,
    MatOptionModule,
    FormsModule,
    MatSelectModule,
    MatDatepickerModule,
    StripHtmlPipe,
    CommonModule,
    MatMenuModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSlideToggleModule
  ],
})
export class ComplaintComponent {
  displayedColumns: string[] = [
    "check-box",
    "complaintNo",
    "status",
    "cnic",
    "gender",
    "email",
    "complaintCategoryName",
    "complaintSubcategoryName",
    "complainantName ",
    "cellPhoneNo",
    "divisionName",
    "action",
  ];

  selection = new SelectionModel<any>(true, []);

  // 'additionalCenter', 'both', 'detail', 'workCode', 'currentProcessId', 'createdBy',  'createdAt', 'helplineIdentifier',, 'districtName', 'tehsilName'
  config = new Config();
  length = 0;
  pageIndex = 0;
  pageSize = 10;
  isLoading = false;
  searchError = false;

  form: FormGroup;
  dataSource: MatTableDataSource<any>;

  dataList: any[] = [];
  categoryList: any[] = [];
  originalCategoryList: any[] = [];
  subCategoryList: any[] = [];
  originalSubbCategoryList: any[] = [];
  districtList: any[] = [];
  tehsilList: any[] = [];
  mouzaList: any[] = [];
  complaintProcessList: any[] = [];

  allDivisionList: any[] = [];
  originalDivisionList: any[] = [];
  allDistrictList: any[] = [];
  originalDistrictList: any[] = [];
  allTehsilList: any[] = [];
  originalTehsilList: any[] = [];
  allMouzaList: any[] = [];
  originalMouzaList: any[] = [];
  assignToUserName: string;
  allComplaintProcessList: any[] = [];
  deleteModel: DeleteModel = {
    title: "DELETE_TITLE",
    message: "COMPLAINT_TYPE_DELETE_MESSAGE",
    deleteButtonText: "DELETE",
    cancelButtonText: "CALCEL",
  };
  // complainantTitle: string[] = ["Mr.", "Ms."];
  // workCodeList: string[] = [
  //   "Department/wings as Operations",
  //   "IT",
  //   "Corruption",
  //   "HR",
  //   "Monitoring",
  // ];
  sourceList: string[] = ["Telephone line", "Email", "WhatsApp", "Hard Copy"];
  displayColumns: string[] = [...this.displayedColumns];

  selectedColumns: { [key: string]: boolean } = {};
  canSeeInfo: boolean = false;
  divisionIds: any[] = [];
  districtIds: any[] = [];
  tehsilIds: any[] = [];
  mouzaIds: any[] = [];
  workFlowStepsds: any[] = [];
  filteredListCategory: any[] = [];
  filteredListSubCategory: any[] = [];
  filteredList: any[] = [];
  filteredListcomplaintProcessList: any[] = [];
  originalComplaintProcessList: any[] = [];
  allComplaints: any[] = [];
  dateRangeForm: FormGroup;
  selectedType = true;
  userId: string | null = null;
  usersListOriginal: any[] = [];
  usersList: any[] = [];
  assignTo: any;
  assignRole: string;
  assignRoleAdmin: boolean;
  userRole: string;
  username: string = '';
  preserveSearch: boolean = false;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("searchComplaint") searchComplaint: ElementRef<HTMLInputElement>;
  @ViewChild("searchSubCat") searchSubCat: ElementRef<HTMLInputElement>;
  @ViewChild("searchDivision") searchDivision: ElementRef<HTMLInputElement>;
  @ViewChild("searchAssignee") searchAssignee: ElementRef<HTMLInputElement>;
  @ViewChild("searchDistrict") searchDistrict: ElementRef<HTMLInputElement>;
  @ViewChild("searchTehsil") searchTehsil: ElementRef<HTMLInputElement>;
  @ViewChild("searchMouza") searchMouza: ElementRef<HTMLInputElement>;
  @ViewChild("searchCurrentProcess")
  searchCurrentProcess: ElementRef<HTMLInputElement>;

  private destroy$ = new Subject<void>();

  constructor(
    public dialog: MatDialog,
    private crudService: GenericCrudService,
    private formBuilder: FormBuilder,
    private route: Router,
    private appDataService: ApplicationDataService,
    private authService: AuthenticationService,
    private tokenStorage: TokenStorageService,
    private datePipe: DatePipe,
    private complaintStateService: ComplaintStateService
  ) {
    this.dataSource = new MatTableDataSource();
    this.dataSource.sortingDataAccessor = (item, property) => {
      const value = item[property];
      return typeof value === 'string' ? value.toLowerCase() : value;
    };
    this.divisionIds = this.tokenStorage.getDivisions();
    this.districtIds = this.tokenStorage.getDistricts();
    this.tehsilIds = this.tokenStorage.getTehsil();
    this.mouzaIds = this.tokenStorage.getMouza();
    this.workFlowStepsds = this.tokenStorage.getWorkItemSteps();
    this.canSeeInfo = this.tokenStorage.getCanseeInfo();
    this.displayedColumns.forEach(
      (column) => (this.selectedColumns[column] = true)
    );
    this.selectedColumns['status'] = true;
    this.selectedColumns['complainantName'] = true;
  }
  updateDisplayedColumns(): void {
    // Start with required columns (check-box is always included at the beginning)
    this.displayedColumns = ["check-box", "complaintNo", "complaintCategoryName", "action"];

    // Ensure check-box is always selected
    this.selectedColumns['check-box'] = true;

    // Add optional columns based on selectedColumns state
    // Status should come after complaintNo (index 2)
    if (this.selectedColumns['status']) {
      this.displayedColumns.splice(2, 0, "status");
    }

    // Add user info columns if permitted
    if (this.canSeeInfo) {
      if (this.selectedColumns['cnic']) {
        this.displayedColumns.splice(this.displayedColumns.indexOf("complaintCategoryName"), 0, "cnic");
      }
      if (this.selectedColumns['email']) {
        this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "email");
      }

      if (this.selectedColumns['gender']) {
        this.displayedColumns.splice(this.displayedColumns.indexOf("complaintCategoryName"), 0, "gender");
      }
      if (this.selectedColumns['complaintSubcategoryName']) {
        this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "complaintSubcategoryName");
      }

      if (this.selectedColumns['complainantName']) {
        this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "complainantName");
      }


      if (this.selectedColumns['cellPhoneNo']) {
        this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "cellPhoneNo");
      }
    }

    if (this.selectedColumns['divisionName']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "divisionName");
    }
    if (this.selectedColumns['districtName']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "districtName");
    }
    if (this.selectedColumns['tehsilName']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "tehsilName");
    }
    if (this.selectedColumns['mouzaName']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "mouzaName");
    }
    if (this.selectedColumns['priority']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "priority");
    }
    if (this.selectedColumns['severity']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "severity");
    }
    // if (this.selectedColumns['complainantTitle']) {
    //   this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "complainantTitle");
    // }
    if (this.selectedColumns['daysRequired']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "daysRequired");
    }
    if (this.selectedColumns['legalFramework']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "legalFramework");
    }
    if (this.selectedColumns['expectedResolutionDate']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "expectedResolutionDate");
    }
    if (this.selectedColumns['complaintAddress']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "complaintAddress");
    }

    if (this.selectedColumns['description']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "description");
    }

    if (this.selectedColumns['complaintSource']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "complaintSource");
    }

    if (this.selectedColumns['assignToName']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "assignToName");
    }

    if (this.selectedColumns['assignToGroupName']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "assignToGroupName");
    }

    if (this.selectedColumns['workCode']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "workCode");
    }

    if (this.selectedColumns['helplineIdentifier']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "helplineIdentifier");
    }

    if (this.canSeeInfo && this.selectedColumns['passportNo']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "passportNo");
    }

    if (this.selectedColumns['segmentName']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "segmentName");
    }

    if (this.canSeeInfo && this.selectedColumns['citizenAddress']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "citizenAddress");
    }

    if (this.selectedColumns['isAnonymous']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "isAnonymous");
    }

    if (this.selectedColumns['otherSource']) {
      this.displayedColumns.splice(this.displayedColumns.indexOf("action"), 0, "otherSource");
    }

  }

  ngOnInit() {
    this.preserveSearch = localStorage.getItem('preserve_search') === 'true';
    if (!this.preserveSearch) {
      this.complaintStateService.clearState();
    }
    //this.role = this.authService.getUserRole();
    this.loadUserid();
    this.getAllUsersData();
    this.form = this.formBuilder.group({
      startDate: [""],
      endDate: [""],
      complainantName: [""],
      complaintNo: [""],
      complaintCategoryId: [""],
      complaintSubcategoryId: [""],
      currentProcessId: [""],
      divisionId: [""],
      districtId: [""],
      tehsilId: [""],
      mouzaId: [""],
      userId: [""],
      divisionsIds: [null],
      assigneeUserName: [this.assignToUserName],
      districtsIds: [null],
      tehsilIds: [null],
      mouzaIds: [null],
      workFlowStepsIds: [null],

      cnic: [""],
      pageNo: [this.pageIndex],
      pageSize: [this.pageSize],
      // cellPhoneNo: ['', [Validators.required, Validators.pattern(/^03\d{9}$/)]],
      cellPhoneNo: [""],
      passportNo: [""],
      address: [""],
      //ComplainDetail
      additionalCenter: ["", []],
      daysRequired: [null],
      status: ["", []],
      assignTo: [this.assignTo],
      //AdditionalDetail
      workCode: ["", []],
      source: ["", []],
      tier: ["", []],
      legalFramework: ["", []], //OnLoad and Disabled
      helplineIdentifier: ["", []],
      complaintDetails: [""],
      expectedResolutionDate: [""],
      actualResolutionDate: [""],
      complaintResolutionDetail: [""],
      //Not Used
      callType: [""],
      callStatus: [""],
      boothCliNumber: [""],
      segment: [""],
      email: [""],
      gender: [""],
      // dateFrom: [new Date(year, month - 1)],
      // dateTo: [today], // Initialize dateTo with current date
      dateFrom: [""],
      dateTo: []
    });

    // Load saved column preferences first
    this.loadSelectedColumns();

    // Set default columns that should always be visible
    // Only set them if they're not already defined in loaded preferences
    if (this.selectedColumns['status'] === undefined) {
      this.selectedColumns['status'] = true;
    }
    if (this.selectedColumns['complainantName'] === undefined) {
      this.selectedColumns['complainantName'] = true;
    }
    if (this.selectedColumns['gender'] === undefined) {
      this.selectedColumns['gender'] = true;
    }
    if (this.selectedColumns['check-box'] === undefined) {
      this.selectedColumns['check-box'] = true;
    }
    if (this.selectedColumns['email'] === undefined) {
      this.selectedColumns['email'] = true;
    }

    // Save the combined preferences (loaded + defaults)
    this.saveSelectedColumns();

    // Update the displayed columns based on current preferences
    this.updateDisplayedColumns();

    // Step 1: immediately apply preserved filters and search — don't wait for dropdowns
    const savedState = this.preserveSearch ? this.complaintStateService.restoreState() : null;
    if (savedState) {
      this.applyFiltersToForm(savedState);
    }
    this.search();

    // Step 2: load all dropdowns in parallel in the background
    forkJoin({
      workflowSteps: this.getAllWorkFlowStepsBySegment(this.authService.getUserSegment()),
      categories: this.getComplaintCategoryBySegment(this.authService.getUserSegment()),
      divisions: this.getDivisions(),
      districts: this.getDistrict(),
      tehsils: this.getTehsil(),
      mouzas: this.getMouza(),
      users: this.getAllUsersData()
    }).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        // Once dropdowns are ready, update UI selections only — no re-search
        if (savedState) {
          this.restoreDropdownSelections(savedState);
        }
      },
      error: (err) => {
        console.error('Error loading dropdown data', err);
      }
    });

    this.f["complaintCategoryId"].valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value) {
          this.getAllComplaintByParentCategory(value);
          this.f["complaintSubcategoryId"].setValue(""); // Reset sub-category when category changes
        }
      });

    this.f["assigneeUserName"].valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        for (let i = 0; i < this.usersList.length; i++) {
          if (this.usersList[i].userId === value) {
            this.assignToUserName = this.usersList[i].userName;

            // Set both controls
            this.f["assigneeUserName"].setValue(this.assignToUserName);
            break;
          }
        }
      });

    this.f["divisionId"].valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        // Reset the lists and form controls
        this.districtList = [];
        this.tehsilList = [];
        this.mouzaList = [];
        this.f["districtId"].setValue("");
        this.f["tehsilId"].setValue("");
        this.f["mouzaId"].setValue("");
        this.f["districtsIds"].setValue(null);
        this.f["tehsilIds"].setValue(null);
        this.f["mouzaIds"].setValue(null);

        if (value) {
          // Filter districts based on the selected division
          this.districtList = this.allDistrictList.filter(
            (d) => d.parentAdminStrId == value
          );
          // Assign original district list
          this.originalDistrictList = [...this.districtList];
        }
      });

    this.f["districtId"].valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.tehsilList = [];
        this.mouzaList = [];
        this.f["tehsilId"].setValue("");
        this.f["mouzaId"].setValue("");
        this.f["tehsilIds"].setValue(null);
        this.f["mouzaIds"].setValue(null);

        if (value) {
          this.tehsilList = this.allTehsilList.filter(
            (d) => d.parentAdminStrId == value
          );
          this.originalTehsilList = [...this.tehsilList];
        }
      });

    this.f["tehsilId"].valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.mouzaList = [];
        this.f["mouzaId"].setValue("");
        this.f["mouzaIds"].setValue(null);

        if (value) {
          this.mouzaList = this.allMouzaList.filter(
            (d) => d.parentAdminStrId == value
          );
          this.originalMouzaList = [...this.mouzaList];
        }
      });
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  deepCopy(data: any) {
    return JSON.parse(JSON.stringify(data));
  }

  // toggleCanSeeInfo(): void {
  //   this.canSeeInfo = !this.canSeeInfo;
  //   this.updateDisplayedColumns();
  //   this.loadSelectedColumns();
  //   this.searchComplaints();
  // }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;

    // Custom sorting logic for case-insensitive sorting
    this.dataSource.sortingDataAccessor = (item, property) => {
      const value = item[property];
      return typeof value === 'string' ? value.toLowerCase() : value;
    };
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Restore form filters and pagination from saved state, then call API
   */
  /**
   * Applies preserved filter values to the form immediately so search() can use them.
   * Does NOT touch dropdown lists (those aren't loaded yet).
   */
  private applyFiltersToForm(state: ComplaintListState): void {
    try {
      this.f['complainantName'].setValue(state.filters.complainantName);
      this.f['complaintNo'].setValue(state.filters.complaintNo);
      this.f['cnic'].setValue(state.filters.cnic);
      this.f['currentProcessId'].setValue(state.filters.currentProcessId);
      this.f['cellPhoneNo'].setValue(state.filters.cellPhoneNo);
      this.f['email'].setValue(state.filters.email);
      this.f['gender'].setValue(state.filters.gender);
      this.f['dateFrom'].setValue(state.filters.dateFrom);
      this.f['dateTo'].setValue(state.filters.dateTo);
      this.f['assignTo'].setValue(state.filters.assignTo);

      // Location IDs go straight to the form — the search API only needs the IDs
      this.f['divisionId'].setValue(state.filters.divisionId, { emitEvent: false });
      this.f['districtId'].setValue(state.filters.districtId, { emitEvent: false });
      this.f['tehsilId'].setValue(state.filters.tehsilId, { emitEvent: false });
      this.f['mouzaId'].setValue(state.filters.mouzaId, { emitEvent: false });

      // Category/subcategory IDs — search API only needs the IDs
      this.f['complaintCategoryId'].setValue(state.filters.complaintCategoryId, { emitEvent: false });
      this.f['complaintSubcategoryId'].setValue(state.filters.complaintSubcategoryId, { emitEvent: false });

      // Pagination
      this.pageIndex = state.pagination.pageIndex;
      this.pageSize = state.pagination.pageSize;
      this.f['pageNo'].setValue(this.pageIndex);
      this.f['pageSize'].setValue(this.pageSize);
    } catch (error) {
      console.error('Error applying preserved filters:', error);
    }
  }

  /**
   * After dropdowns have loaded, updates the UI lists so the selected values
   * are visible in the dropdowns. Does NOT call search() again.
   */
  private restoreDropdownSelections(state: ComplaintListState): void {
    try {
      // Filter hierarchical lists so the selected option is present
      if (state.filters.divisionId) {
        this.districtList = this.allDistrictList.filter(d => d.parentAdminStrId == state.filters.divisionId);
        this.originalDistrictList = [...this.districtList];
      }
      if (state.filters.districtId) {
        this.tehsilList = this.allTehsilList.filter(d => d.parentAdminStrId == state.filters.districtId);
        this.originalTehsilList = [...this.tehsilList];
      }
      if (state.filters.tehsilId) {
        this.mouzaList = this.allMouzaList.filter(d => d.parentAdminStrId == state.filters.tehsilId);
        this.originalMouzaList = [...this.mouzaList];
        this.f['mouzaId'].setValue(state.filters.mouzaId, { emitEvent: false });
      }

      // Load subcategory list so the selected subcategory renders in the dropdown
      if (state.filters.complaintCategoryId) {
        this.appDataService.getAllComplaintByParentCategory(state.filters.complaintCategoryId).subscribe({
          next: (res: any) => {
            this.subCategoryList = res?.data;
            this.originalSubbCategoryList = [...this.subCategoryList];
            this.f['complaintSubcategoryId'].setValue(state.filters.complaintSubcategoryId, { emitEvent: false });
          }
        });
      }
    } catch (error) {
      console.error('Error restoring dropdown selections:', error);
    }
  }

  /**
   * Save current filters and pagination before navigating away
   */
  private saveCurrentState(): void {
    if (!this.preserveSearch) return;

    const state: Partial<ComplaintListState> = {
      filters: {
        complainantName: this.f['complainantName'].value,
        complaintNo: this.f['complaintNo'].value,
        complaintCategoryId: this.f['complaintCategoryId'].value,
        complaintSubcategoryId: this.f['complaintSubcategoryId'].value,
        currentProcessId: this.f['currentProcessId'].value,
        divisionId: this.f['divisionId'].value,
        districtId: this.f['districtId'].value,
        tehsilId: this.f['tehsilId'].value,
        mouzaId: this.f['mouzaId'].value,
        cnic: this.f['cnic'].value,
        cellPhoneNo: this.f['cellPhoneNo'].value,
        email: this.f['email'].value,
        gender: this.f['gender'].value,
        assignTo: this.f['assignTo'].value,
        dateFrom: this.f['dateFrom'].value,
        dateTo: this.f['dateTo'].value,
      },
      pagination: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
    };

    this.complaintStateService.saveState(state);
  }
  getAllUsersData() {
    return this.appDataService.getAllInternalUsers().pipe(
      takeUntil(this.destroy$),
      tap((res: any) => {
        this.usersListOriginal = res?.data;
        this.usersList = [...this.usersListOriginal];

        if (this.userRole === "ADMIN" || this.userRole === "DASHBOARD") {
          this.assignRoleAdmin = false;
        } else {
          this.assignRoleAdmin = true;
        }

        for (let i = 0; i < this.usersList.length; i++) {
          if (this.usersList[i].userId === this.assignTo) {
            this.assignToUserName = this.usersList[i].userName;
            this.assignRole = this.usersList[i].role;
            // Set both controls
            this.f["assigneeUserName"].setValue(this.assignToUserName);
            break;
          }
        }
        this.f["assigneeUserName"].disable();
      }),
      catchError(() => of(null))
    );
  }
  loadUserid() {
    const permissions = localStorage.getItem("permissions");
    if (permissions) {
      try {
        const parsedPermissions = JSON.parse(permissions);
        const getUserId = parsedPermissions.USER;
        const getUserRole = parsedPermissions.role;
        this.userRole = getUserRole;
        this.username = this.tokenStorage.getEmail() || '';
        if (getUserId) {
          if (getUserRole === "ADMIN" || getUserRole === "DASHBOARD") {
            this.assignTo = "";
          } else {
            this.assignTo = getUserId;
          }
        }

      } catch (error) {
        console.error("Error parsing localStorage data:", error);
      }
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }


  toggleColumn(column: string, event: any) {
    // Update the selected columns state
    this.selectedColumns[column] = event.checked;

    // Save the updated selection to localStorage first
    this.saveSelectedColumns();

    // Then update the displayed columns based on the current state
    this.updateDisplayedColumns();
  }

  saveSelectedColumns() {
    localStorage.setItem(
      "selectedColumns",
      JSON.stringify(this.selectedColumns)
    );
  }

  loadSelectedColumns() {
    const savedColumns = localStorage.getItem("selectedColumns");
    if (savedColumns) {
      this.selectedColumns = JSON.parse(savedColumns);
    }
  }

  onPreserveSearchChange(event: any) {
    this.preserveSearch = event.checked;
    localStorage.setItem('preserve_search', this.preserveSearch.toString());
  }

  getComplaintCategoryBySegment(id: number) {
    return this.appDataService.getAllComplaintCategoriesBySegment(id).pipe(
      takeUntil(this.destroy$),
      tap((res: any) => {
        this.categoryList = res?.data;
        this.originalCategoryList = [...this.categoryList];
      }),
      catchError(() => of(null))
    );
  }
  getAllComplaintByParentCategory(id: number) {
    this.appDataService.getAllComplaintByParentCategory(id).subscribe({
      next: (res: any) => {
        this.subCategoryList = res?.data;
        this.originalSubbCategoryList = [...this.subCategoryList];
      },
    });
  }

  logData(d: any) {
    console.log("Attachment clicked:", d);
  }
  clear() {
    this.form.reset();
    this.f["divisionId"].setValue(""); // Set value to empty string to select 'ALL' 
    this.f["districtId"].setValue("");
    this.f["tehsilId"].setValue("");
    this.f["mouzaId"].setValue("");
    this.f["userId"].reset();
    this.f["dateFrom"].reset();
    this.f["dateTo"].reset();

    // Reset viewable dropdown lists
    this.districtList = [];
    this.tehsilList = [];
    this.mouzaList = [];
    this.subCategoryList = [];

    this.originalDistrictList = [];
    this.originalTehsilList = [];
    this.originalMouzaList = [];
    this.originalSubbCategoryList = [];

    // NOTE: We no longer re-fetch master data or clear master lists (allDistrictList etc.) here 
    // to prevent race conditions during selection. Initial data is already loaded in ngOnInit.
    
    this.searchComplaints();

    if (this.assignRoleAdmin) {
      const loggedInUser = this.usersList.find(
        (user) => user.userName === this.assignToUserName
      );
      if (loggedInUser) {
        this.f["assignTo"].setValue(loggedInUser.userId);
      }
    } else {
      this.f["assignTo"].setValue("");
    }
    this.selection.clear();
  }
  handlePageEvent(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.f["pageSize"].setValue(this.pageSize);
    this.f["pageNo"].setValue(this.pageIndex);
    this.search();
  }
  searchComplaints() {
    this.pageSize = 10;
    this.pageIndex = 0;
    this.f["pageSize"].setValue(this.pageSize);
    this.f["pageNo"].setValue(this.pageIndex);
    this.search();
  }
  search() {
    // Map singular ID selections to array payloads expected by the backend
    if (this.f["divisionId"].value === "" || this.f["divisionId"].value === null) {
      this.f["divisionsIds"].setValue(this.divisionIds);
    } else {
      this.f["divisionsIds"].setValue([this.f["divisionId"].value]);
    }

    if (this.f["districtId"].value === "" || this.f["districtId"].value === null) {
      this.f["districtsIds"].setValue(null);
    } else {
      this.f["districtsIds"].setValue([this.f["districtId"].value]);
    }

    if (this.f["tehsilId"].value === "" || this.f["tehsilId"].value === null) {
      this.f["tehsilIds"].setValue(null);
    } else {
      this.f["tehsilIds"].setValue([this.f["tehsilId"].value]);
    }

    if (this.f["mouzaId"].value === "" || this.f["mouzaId"].value === null) {
      this.f["mouzaIds"].setValue(null);
    } else {
      this.f["mouzaIds"].setValue([this.f["mouzaId"].value]);
    }

    this.f["dateFrom"].setValue(
      this.datePipe.transform(this.form.value?.dateFrom, "yyyy-MM-dd")
    );
    this.f["dateTo"].setValue(
      this.datePipe.transform(this.form.value?.dateTo, "yyyy-MM-dd")
    );
    if (this.f["gender"].value == "") {
      this.f["gender"].setValue(null);
    } else {
      this.f["gender"].setValue(this.f["gender"].value);
    }


    this.isLoading = true;
    this.searchError = false;

    this.appDataService.searchComplaint(this.form.value).subscribe({
      next: (res: any) => {
        this.dataSource.data = res?.data?.data;
        this.length = res?.data?.totalRows;
        this.selection.clear();
        this.isLoading = false;

        localStorage.setItem("totalRows", this.length.toString());

        if (this.preserveSearch) {
          this.saveCurrentState();
        } else {
          this.complaintStateService.clearState();
        }
      },
      error: (e) => {
        console.error("Error fetching data:", e);
        this.isLoading = false;
        this.searchError = true;
      },
    });
  }
  filterStatus(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.complaintProcessList = this.complaintProcessList.filter(
        (complaintProcess) =>
          complaintProcess.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.complaintProcessList = this.originalComplaintProcessList; // Reset to original data
    }
  }

  filterComplaintCategory(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.categoryList = this.categoryList.filter((category) =>
        category.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.categoryList = this.originalCategoryList; // Reset to original data
    }
  }

  filterSubCategory(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.subCategoryList = this.subCategoryList.filter((subCategory) =>
        subCategory.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.subCategoryList = this.originalSubbCategoryList; // Reset to original data
    }
  }

  getDivisions() {
    return this.appDataService.getAdminStructureByIds(this.divisionIds).pipe(
      takeUntil(this.destroy$),
      tap((res: any) => {
        this.allDivisionList = res?.data;
        this.originalDivisionList = [...this.allDivisionList];
      }),
      catchError(() => of(null))
    );
  }
  getDistrict() {
    return this.appDataService.getAdminStructureByIds(this.districtIds).pipe(
      takeUntil(this.destroy$),
      tap((res: any) => {
        this.allDistrictList = res?.data;
      }),
      catchError(() => of(null))
    );
  }
  getTehsil() {
    return this.appDataService.getAdminStructureByIds(this.tehsilIds).pipe(
      takeUntil(this.destroy$),
      tap((res: any) => {
        this.allTehsilList = res?.data;
      }),
      catchError(() => of(null))
    );
  }
  getMouza() {
    return this.appDataService.getAdminStructureByIds(this.mouzaIds).pipe(
      takeUntil(this.destroy$),
      tap((res: any) => {
        this.allMouzaList = res?.data;
      }),
      catchError(() => of(null))
    );
  }

  filterDivisions(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    // Filter in-place using this.allDivisionList
    if (searchTerm) {
      this.allDivisionList = this.allDivisionList.filter((division) =>
        division.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.allDivisionList = this.originalDivisionList; // Reset to original data
    }
  }
  filterAssignee(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.usersListOriginal = this.usersListOriginal.filter((assignee) =>
        assignee.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.usersListOriginal = this.usersListOriginal; // Reset to original data
    }
  }
  filterDistricts(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    // Filter in-place using this.districtList
    if (searchTerm) {
      this.districtList = this.districtList.filter((district) =>
        district.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.districtList = this.originalDistrictList; // Reset to original data
    }
  }

  filterTehsil(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    // Filter in-place using this.tehsilList
    if (searchTerm) {
      this.tehsilList = this.tehsilList.filter((tehsil) =>
        tehsil.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.tehsilList = this.originalTehsilList; // Reset to original data
    }
  }

  filterMouza(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    // Filter in-place using this.mouzaList
    if (searchTerm) {
      this.mouzaList = this.mouzaList.filter((mouza) =>
        mouza.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.mouzaList = this.originalMouzaList; // Reset to original data
    }
  }

  clearSearch(selectedOption: string) {
    switch (selectedOption) {
      case "category":
        this.searchComplaint.nativeElement.value = "";
        this.categoryList = this.originalCategoryList;
        break;
      case "subCategory":
        this.searchSubCat.nativeElement.value = "";
        this.subCategoryList = this.originalSubbCategoryList;
        break;
      case "division":
        this.searchDivision.nativeElement.value = "";
        this.allDivisionList = this.originalDivisionList;
        break;
      case "district":
        this.searchDistrict.nativeElement.value = "";
        this.districtList = this.originalDistrictList;
        break;
      case "tehsil":
        this.searchTehsil.nativeElement.value = "";
        this.tehsilList = this.originalTehsilList;
        break;
      case "mouza":
        this.searchMouza.nativeElement.value = "";
        this.mouzaList = this.originalMouzaList;
        break;
      case "currentProcess":
        this.searchCurrentProcess.nativeElement.value = "";
        this.complaintProcessList = this.originalComplaintProcessList;
        break;
    }
  }

  getAllWorkFlowStepsBySegment(id: number) {
    return this.appDataService.getAllWorkFlowStepsBySegment(id).pipe(
      takeUntil(this.destroy$),
      tap((res: any) => {
        this.complaintProcessList = res?.data;
        this.originalComplaintProcessList = [...this.complaintProcessList];
      }),
      catchError(() => of(null))
    );
  }

  add() {
    // const dialogRef = this.dialog.open(ComplaintAddEditDialogComponent);
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.dataList.push(result);
    //     this.dataSource = new MatTableDataSource(this.dataList);
    //     this.dataSource.paginator = this.paginator;
    //     this.dataSource.sort = this.sort;
    //     console.log(`Dialog result: ${result}`);
    //   }
    // });
    // const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
    //   data: {name: this.name, animal: this.animal},
    // });
  }

  edit(updateRecord: any, rowNumber: number) {
    this.route.navigate(["complaint/edit/" + updateRecord?.complaintId]);
  }
  delete(deleteRecord: any, rowNumber: number) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: this.deleteModel,
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.crudService
          .delete(deleteRecord?.complaintId, AppUrlConstants.COMPLAINT_URL)
          .subscribe({
            next: (res: any) => {
              this.dataSource = new MatTableDataSource(res?.data);
              this.dataSource.sort = this.sort;
            },
            error: (e) => {
              if (e?.status == 409) {
                if (e?.error?.errors !== null) {
                  for (const property in e.error.errors) {
                    this.openAlert(e.error.errors[property]);
                  }
                } else {
                  this.openAlert(e?.error?.message);
                }
              }
            },
          });
      }
    });
  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: 'OK'
        }
      },
    });
  }

  maskEmail(email: string): string {
    if (!email || email.length < 4) return "***";

    const atIndex = email.indexOf("@");
    if (atIndex === -1) return "Invalid email";

    const localPart = email.substring(0, atIndex);
    const domain = email.substring(atIndex);

    const visiblePart = localPart.slice(0, 4);
    const maskedPart = "*".repeat(localPart.length - 1);
    return `${visiblePart}${maskedPart}`;
  }

  maskPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber || phoneNumber.length < 4) return "****";

    // Format as +92XXXXXXXXXX
    let formattedNumber = phoneNumber;
    if (phoneNumber.startsWith("03")) {
      formattedNumber = "+92" + phoneNumber.substring(1);
    }

    const visiblePart = formattedNumber.substring(0, 5); // Show +9234
    const maskedPart = "*".repeat(formattedNumber.length - 5);

    return `${visiblePart}${maskedPart}`;
  }
  sendEmail(data: any, message?: string) {
    const fullEmail = data?.email ?? ""; // Store the full email
    const maskedEmail = this.maskEmail(fullEmail); // Create masked version for display

    const sendMessageDto: SendMessageModel = {
      title: "SEND_EMAIL",
      sendToLabel: "EMAIL",
      sendTo: maskedEmail,
      message: message ?? "",
      complaintId: data?.complaintId ?? 0
    };

    const dialogRef = this.dialog.open(SendEmailDialogComponent, {
      data: {
        ...sendMessageDto,
        fullEmail: fullEmail // Pass the full email separately
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      //console.log(result);
    });
  }

  sendSms(data: any, message?: string) {
    const fullPhoneNumber = data?.cellPhoneNo ?? "";
    const maskedPhoneNumber = this.maskPhoneNumber(fullPhoneNumber);

    let sendMessageDto: SendMessageModel = {
      title: "SEND_SMS",
      sendToLabel: "PHONE_NUMBER",
      sendTo: maskedPhoneNumber,
      message: message ?? "",
      complaintId: data?.complaintId ?? ""
    };

    const dialogRef = this.dialog.open(SendSmsDialogComponent, {
      data: {
        ...sendMessageDto,
        fullPhoneNumber: fullPhoneNumber // Pass the full phone number separately
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }
  openDropModal(complaint: any) {
    const dialogRef = this.dialog.open(DropDialogComponent, {
      data: {
        complaintId: complaint?.complaintId,
      },
    });
  }

  openAppealModal(complaint: any) {
    const dialogRef = this.dialog.open(AppealDialogComponent, {
      data: {
        complaintId: complaint?.complaintId,
      },
    });
  }

  // Check if actions should be disabled for DASHBOARD role
  isActionDisabled(): boolean {
    return this.userRole === 'DASHBOARD';
  }

  private readonly INVALID_MOBILES = ['03000000000', '+923000000000'];
  private readonly INVALID_EMAILS = ['anonymous@pulse.gop.pk', 'anonymous@pulse.com'];

  isValidMobile(mobile: string): boolean {
    if (!mobile || mobile.trim() === '') return false;
    return !this.INVALID_MOBILES.includes(mobile.trim());
  }

  isValidEmail(email: string): boolean {
    if (!email || email.trim() === '') return false;
    return !this.INVALID_EMAILS.includes(email.trim().toLowerCase());
  }

  // Check if reopen button should be visible for GRM-Specialist
  showReopenButton(row: any): boolean {

    return this.username?.toLowerCase() === 'grm-specialist' &&
      row?.currentProcess?.name?.toLowerCase() === 'drop' &&
      row?.segmentId === 1;
  }

  // Open reopen modal dialog
  openReopenModal(complaint: any) {
    const dialogRef = this.dialog.open(ReopenDialogComponent, {
      data: {
        complaintId: complaint?.complaintId,
        complaintProcessList: this.complaintProcessList
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.submitted) {
        this.searchComplaints();
      }
    });
  }

  async downloadAllAsPdf(exportType: string): Promise<void> {
    // Handle form values similar to search method
    if (this.form.get("divisionId")?.value === "") {
      this.form.get("divisionsIds")?.setValue(this.divisionIds);
    } else if (this.form.get("divisionId")?.value != null) {
      this.form
        .get("divisionsIds")
        ?.setValue([this.form.get("divisionId")?.value]);
    }
    if (this.form.get("districtId")?.value === "") {
      this.form.get("districtsIds")?.reset();
    } else if (this.form.get("districtId")?.value != null) {
      this.form
        .get("districtsIds")
        ?.setValue([this.form.get("districtId")?.value]);
    }
    if (this.form.get("tehsilId")?.value === "") {
      this.form.get("tehsilIds")?.reset();
    } else if (this.form.get("tehsilId")?.value != null) {
      this.form.get("tehsilIds")?.setValue([this.form.get("tehsilId")?.value]);
    }
    if (this.form.get("mouzaId")?.value === "") {
      this.form.get("mouzaIds")?.reset();
    } else if (this.form.get("mouzaId")?.value != null) {
      this.form.get("mouzaIds")?.setValue([this.form.get("mouzaId")?.value]);
    }

    // Determine whether to fetch all data or current data
    if (exportType === "all") {
      // Retrieve totalRows from local storage and set pageSize
      const totalRows = localStorage.getItem("totalRows") ?? this.length.toString();
      if (totalRows) {
        this.pageSize = parseInt(totalRows, 10);
        this.form.get("pageSize")?.setValue(this.pageSize);
        localStorage.removeItem("totalRows");
      }
    }

    // Check if there are selected rows for 'current' export
    if (exportType === 'current') {
      if (this.selection.selected.length === 0) {
        this.openAlert("Please select the rows you would like to export");
        return;
      }
      this.processPdfExport(this.selection.selected);
      return;
    }

    // Fetch data based on form values
    this.appDataService.searchComplaint(this.form.value).subscribe({
      next: (res: any) => {
        this.processPdfExport(res?.data?.data || []);
      },
      error: (e) => {
        console.error("Error fetching complaints", e);
      },
    });
  }

  processPdfExport(data: any[]): void {
    this.allComplaints = data;

    // Create a printable HTML document with proper RTL support
    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      this.openAlert("Please allow  to generate the PDF");
      return;
    }

    // Build table headers based on selected columns
    let tableHeaders = '';
    // Sr No. column is always included in PDF export
    tableHeaders += '<th class="center-text">Sr No./<span class="urdu-text">نمبر شمار</span></th>';

    if (this.selectedColumns["complaintNo"]) {
      tableHeaders += '<th class="center-text">Complaint No/<span class="urdu-text">شکایت نمبر</span></th>';
    }
    if (this.selectedColumns["status"]) {
      tableHeaders += '<th class="center-text">Status/<span class="urdu-text">حالت</span></th>';
    }

    if (this.selectedColumns["cnic"] && this.canSeeInfo) {
      tableHeaders += '<th class="center-text">CNIC/<span class="urdu-text">شناختی کارڈ</span></th>';
    }


    if (this.selectedColumns["gender"] && this.canSeeInfo) {
      tableHeaders += '<th class="center-text">Gender/<span class="urdu-text">جنس</span></th>';
    }
    if (this.selectedColumns["email"] && this.canSeeInfo) {
      tableHeaders += '<th class="center-text">Email/<span class="urdu-text">ای میل</span></th>';
    }
    if (this.selectedColumns["complaintCategoryName"]) {
      tableHeaders += '<th>Category/<span class="urdu-text">قسم</span></th>';
    }
    if (this.selectedColumns["complaintSubcategoryName"]) {
      tableHeaders += '<th>Subcategory/<span class="urdu-text">ذیلی قسم</span></th>';
    }
    if (this.selectedColumns["complainantName"] && this.canSeeInfo) {
      tableHeaders += '<th>Complainant/<span class="urdu-text">شکایت کنندہ</span></th>';
    }
    if (this.selectedColumns["cellPhoneNo"] && this.canSeeInfo) {
      tableHeaders += '<th class="center-text">Phone/<span class="urdu-text">فون</span></th>';
    }
    if (this.selectedColumns["divisionName"]) {
      tableHeaders += '<th>Division/<span class="urdu-text">ڈویژن</span></th>';
    }
    if (this.selectedColumns["districtName"]) {
      tableHeaders += '<th>District/<span class="urdu-text">ضلع</span></th>';
    }
    if (this.selectedColumns["tehsilName"]) {
      tableHeaders += '<th>Tehsil/<span class="urdu-text">تحصیل</span></th>';
    }
    if (this.selectedColumns["mouzaName"]) {
      tableHeaders += '<th>Mouza/<span class="urdu-text">موضع</span></th>';
    }
    if (this.selectedColumns["priority"]) {
      tableHeaders += '<th class="center-text">Priority/<span class="urdu-text">ترجیح</span></th>';
    }
    if (this.selectedColumns["severity"]) {
      tableHeaders += '<th class="center-text">Severity/<span class="urdu-text">شدت</span></th>';
    }
    if (this.selectedColumns["daysRequired"]) {
      tableHeaders += '<th class="center-text">Days Required/<span class="urdu-text">مطلوبہ دن</span></th>';
    }
    if (this.selectedColumns["legalFramework"]) {
      tableHeaders += '<th>Legal Framework/<span class="urdu-text">قانونی ڈھانچہ</span></th>';
    }
    if (this.selectedColumns["expectedResolutionDate"]) {
      tableHeaders += '<th class="center-text">Expected Resolution/<span class="urdu-text">متوقع حل</span></th>';
    }
    if (this.selectedColumns["complaintAddress"]) {
      tableHeaders += '<th>Address/<span class="urdu-text">پتہ</span></th>';
    }

    if (this.selectedColumns["description"]) {
      tableHeaders += '<th>Description/<span class="urdu-text">تفصیل</span></th>';
    }
    if (this.selectedColumns["complaintSource"]) {
      tableHeaders += '<th class="center-text">Source/<span class="urdu-text">ذریعہ</span></th>';
    }
    if (this.selectedColumns["assignToName"]) {
      tableHeaders += '<th>Assign To/<span class="urdu-text">تفویض</span></th>';
    }
    if (this.selectedColumns["assignToGroupName"]) {
      tableHeaders += '<th>Group Assign To/<span class="urdu-text">گروپ تفویض</span></th>';
    }
    if (this.selectedColumns["workCode"]) {
      tableHeaders += '<th class="center-text">Work Code/<span class="urdu-text">ورک کوڈ</span></th>';
    }
    if (this.selectedColumns["helplineIdentifier"]) {
      tableHeaders += '<th class="center-text">Helpline Identifier/<span class="urdu-text">ہیلپ لائن</span></th>';
    }
    if (this.selectedColumns["passportNo"] && this.canSeeInfo) {
      tableHeaders += '<th class="center-text">Passport No/<span class="urdu-text">پاسپورٹ نمبر</span></th>';
    }
    if (this.selectedColumns["segmentName"]) {
      tableHeaders += '<th class="center-text">Segment/<span class="urdu-text">سیگمنٹ</span></th>';
    }
    if (this.selectedColumns["citizenAddress"] && this.canSeeInfo) {
      tableHeaders += '<th>Citizen Address/<span class="urdu-text">شہری کا پتہ</span></th>';
    }
    if (this.selectedColumns["isAnonymous"]) {
      tableHeaders += '<th class="center-text">Anonymous/<span class="urdu-text">گمنام</span></th>';
    }
    if (this.selectedColumns["otherSource"]) {
      tableHeaders += '<th>Other Forum/<span class="urdu-text">دوسرا فورم</span></th>';
    }


    // Build table rows based on selected columns and data
    const tableRows = this.allComplaints.map((complaint: any, index: number) => {
      let row = '<tr>';

      // Sr No. column is always included in PDF export
      row += `<td class="center-text">${index + 1}</td>`;

      if (this.selectedColumns["complaintNo"]) {
        row += `<td class="center-text">${complaint.complaintNo || ''}</td>`;
      }
      if (this.selectedColumns["status"]) {
        row += `<td class="center-text"><span class="urdu-text">${complaint.currentProcess?.name || ''}</span></td>`;
      }
      if (this.selectedColumns["cnic"] && this.canSeeInfo) {
        row += `<td class="center-text">${complaint.cnic || ''}</td>`;
      }
      if (this.selectedColumns["gender"] && this.canSeeInfo) {
        row += `<td class="center-text">${complaint.gender || ''}</td>`;
      }
      if (this.selectedColumns["email"] && this.canSeeInfo) {
        row += `<td class="center-text">${complaint.email || ''}</td>`;
      }
      if (this.selectedColumns["complaintCategoryName"]) {
        row += `<td><span class="urdu-text">${complaint.complaintCategoryName || ''}</span></td>`;
      }
      if (this.selectedColumns["complaintSubcategoryName"]) {
        row += `<td><span class="urdu-text">${complaint.complaintSubcategoryName || ''}</span></td>`;
      }
      if (this.selectedColumns["complainantName"] && this.canSeeInfo) {
        row += `<td><span class="urdu-text">${complaint.complainantName || ''}</span></td>`;
      }
      if (this.selectedColumns["cellPhoneNo"] && this.canSeeInfo) {
        row += `<td class="center-text">${complaint.cellPhoneNo || ''}</td>`;
      }
      if (this.selectedColumns["divisionName"]) {
        row += `<td><span class="urdu-text">${complaint.divisionName || ''}</span></td>`;
      }
      if (this.selectedColumns["districtName"]) {
        row += `<td><span class="urdu-text">${complaint.districtName || ''}</span></td>`;
      }
      if (this.selectedColumns["tehsilName"]) {
        row += `<td><span class="urdu-text">${complaint.tehsilName || ''}</span></td>`;
      }
      if (this.selectedColumns["mouzaName"]) {
        row += `<td><span class="urdu-text">${complaint.mouzaName || ''}</span></td>`;
      }
      if (this.selectedColumns["priority"]) {
        row += `<td class="center-text">${complaint.priority || ''}</td>`;
      }
      if (this.selectedColumns["severity"]) {
        row += `<td class="center-text">${complaint.severity || ''}</td>`;
      }
      if (this.selectedColumns["daysRequired"]) {
        row += `<td class="center-text">${complaint.daysRequired || ''}</td>`;
      }
      if (this.selectedColumns["legalFramework"]) {
        row += `<td><span class="urdu-text">${complaint.legalFramework || ''}</span></td>`;
      }
      if (this.selectedColumns["expectedResolutionDate"]) {
        const date = complaint.expectedResolutionDate ? this.datePipe.transform(complaint.expectedResolutionDate, 'dd-MM-yyyy') : '';
        row += `<td class="center-text">${date}</td>`;
      }
      if (this.selectedColumns["complaintAddress"]) {
        row += `<td><span class="urdu-text">${complaint.complaintAddress || ''}</span></td>`;
      }

      if (this.selectedColumns["description"]) {
        // Strip HTML tags from description
        const plainText = (complaint.complaintDetails || '').replace(/<[^>]*>/g, '');
        row += `<td><span class="urdu-text">${plainText}</span></td>`;
      }
      if (this.selectedColumns["complaintSource"]) {
        row += `<td class="center-text">${complaint.complaintSource || ''}</td>`;
      }
      if (this.selectedColumns["assignToName"]) {
        row += `<td>${complaint.assignToName || ''}</td>`;
      }
      if (this.selectedColumns["assignToGroupName"]) {
        row += `<td>${complaint.assignToGroupName || ''}</td>`;
      }
      if (this.selectedColumns["workCode"]) {
        row += `<td class="center-text">${complaint.workCode || ''}</td>`;
      }
      if (this.selectedColumns["helplineIdentifier"]) {
        row += `<td class="center-text">${complaint.helplineIdentifier || ''}</td>`;
      }
      if (this.selectedColumns["passportNo"] && this.canSeeInfo) {
        row += `<td class="center-text">${complaint.passportNo || ''}</td>`;
      }
      if (this.selectedColumns["segmentName"]) {
        row += `<td class="center-text">${complaint.segmentName || ''}</td>`;
      }
      if (this.selectedColumns["citizenAddress"] && this.canSeeInfo) {
        row += `<td><span class="urdu-text">${complaint.address || ''}</span></td>`;
      }
      if (this.selectedColumns["isAnonymous"]) {
        row += `<td class="center-text">${complaint.isAnonymous ? 'Yes' : 'No'}</td>`;
      }
      if (this.selectedColumns["otherSource"]) {
        row += `<td>${complaint.otherSource || ''}</td>`;
      }

      row += '</tr>';
      return row;
    }).join('');

    // Write the HTML content with proper RTL support and logos
    printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Compalints</title>
          <meta charset="UTF-8">
          <style>
            @import url('https://fonts.googleapis.com/earlyaccess/notonastaliqurdu.css');

            @page {
              size: A4 landscape;
              margin: 5mm;
            }

            * {
              box-sizing: border-box;
            }

            html, body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
              width: 100%;
              min-height: 100%;
              position: relative;
            }

            .page-wrapper {
              min-height: 100vh;
              display: flex;
              flex-direction: column;
            }

            .content {
              flex: 1;
              padding: 10px;
            }

            h1 {
              text-align: center;
              margin-bottom: 10px;
              margin-top: 5px;
              font-size: 16px;
            }

            .table-container {
              width: 100%;
              overflow-x: visible;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 10px;
              font-size: 8px;
              table-layout: auto;
            }

            td, th {
              border: 1px solid #ddd;
              padding: 3px 4px;
              font-size: 12px;
              text-align: center;
              word-wrap: break-word;
              max-width: 120px;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            th {
              background-color:white;
              color: black;
              font-weight: 700;
              font-size: 10px;
              font:bold
              white-space: nowrap;
            }
              

            .urdu-text {
              font-family: 'Noto Nastaliq Urdu', serif;
              direction: rtl;
              text-align: right;
              line-height: 1.4;
              font-size: 8px;
            }

            th .urdu-text {
              font-size: 7px;
            }

            .center-text {
              text-align: center;
            }

            .logo-container {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 10px 0;
              margin: 0;
              background-color: white;
            }

            .logo-container img {
              margin: 0 10px;
            }

            .logo-container img:first-child {
              height: 50px;
              width: auto;
            }

            .logo-container img:last-child {
              height: 35px;
              width: auto;
            }

            .footer {
              text-align: center;
              padding: 10px 0;
              font-size: 12px;
              color: #666;
              margin-top: auto;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 5px;
            }

            .footer img {
              height: 10px;
              width: auto;
              vertical-align: middle;
            }

            @media print {
              html, body {
                width: 100%;
                height: 100%;
                margin: 0;
                padding: 0;
              }

              .page-wrapper {
                min-height: 100%;
              }

              button {
                display: none;
              }

              table {
                font-size: 7px;
                page-break-inside: auto;
              }

              thead {
                display: table-header-group;
              }

              tbody {
                display: table-row-group;
              }

              tr {
                page-break-inside: avoid;
                page-break-after: auto;
                break-inside: avoid;
              }

              td, th {
                page-break-inside: avoid;
                break-inside: avoid;
              }

              td, th {
                font-size: 7px;
                padding: 2px 3px;
              }

              th .urdu-text, td .urdu-text {
                font-size: 7px;
              }

              .logo-container {
                padding: 5px 0;
              }

              .logo-container img:first-child {
                height: 40px;
              }

              .logo-container img:last-child {
                height: 30px;
              }

              .footer {
                position: fixed;
                bottom: 0;
                left: 0;
                right: 0;
                padding: 10px 0;
                background-color: white;
              }

              .content {
                padding-bottom: 50px;
              }

              .table-container {
                margin-bottom: 40px;
              }
            }
          </style>
        </head>
        <body>
        <div class="page-wrapper">
  <div class="logo-container">
    <img src="/assets/img/logo.png" alt="Logo">
    <img src="/assets/img/pulselogo.png" alt="Pulse Logo">
  </div>
  <div class="content">
    <h1>Complaints / شکایات </h1>
    <div class="table-container">
      <table>
        <thead>
          <tr>
            ${tableHeaders}
          </tr>
        </thead>
        <tbody>
          ${tableRows}
        </tbody>
      </table>
    </div>
  </div>
</div>

  <script>
// Wait for both fonts and images to load before printing
Promise.all([
  document.fonts.ready,
  ...Array.from(document.images).map(img =>
    img.complete ? Promise.resolve() : new Promise(resolve => {
      img.onload = resolve;
      img.onerror = resolve;
    })
  )
]).then(() => {
  setTimeout(() => {
    window.print();
  }, 500);
});
</script>
  </body>
  </html>
    `);

    printWindow.document.close();

    // Reset pageSize after exporting
    this.pageSize = 10;
    this.form.get("pageSize")?.setValue(this.pageSize);
  }

  downloadAllAsExcel(exportType: string) {
    // Handle form values similar to search method
    if (this.form.get("divisionId")?.value === "") {
      this.form.get("divisionsIds")?.setValue(this.divisionIds);
    } else if (this.form.get("divisionId")?.value != null) {
      this.form
        .get("divisionsIds")
        ?.setValue([this.form.get("divisionId")?.value]);
    }
    if (this.form.get("districtId")?.value === "") {
      this.form.get("districtsIds")?.reset();
    } else if (this.form.get("districtId")?.value != null) {
      this.form
        .get("districtsIds")
        ?.setValue([this.form.get("districtId")?.value]);
    }
    if (this.form.get("tehsilId")?.value === "") {
      this.form.get("tehsilIds")?.reset();
    } else if (this.form.get("tehsilId")?.value != null) {
      this.form.get("tehsilIds")?.setValue([this.form.get("tehsilId")?.value]);
    }
    if (this.form.get("mouzaId")?.value === "") {
      this.form.get("mouzaIds")?.reset();
    } else if (this.form.get("mouzaId")?.value != null) {
      this.form.get("mouzaIds")?.setValue([this.form.get("mouzaId")?.value]);
    }

    // Determine whether to fetch all data or current data
    if (exportType === "all") {
      // Retrieve totalRows from local storage and set pageSize
      const totalRows = localStorage.getItem("totalRows");
      if (totalRows) {
        this.pageSize = parseInt(totalRows, 10); // Convert to number if needed
        this.f["pageSize"].setValue(this.pageSize);
      }
    }
    // Check if there are selected rows for 'current' export
    if (exportType === 'current') {
      if (this.selection.selected.length === 0) {
        this.openAlert("Please select the rows you would like to export");
        return;
      }
      this.processExcelExport(this.selection.selected);
      return;
    }

    // Fetch data based on form values
    this.appDataService.searchComplaint(this.form.value).subscribe({
      next: (res: any) => {
        this.processExcelExport(res?.data?.data || []);
      },
      error: (e) => {
        console.error("Error fetching complaints", e);
      },
    });
  }

  processExcelExport(data: any[]): void {
    this.allComplaints = data;

    // Convert data to CSV format
    const csvData = this.convertToCsv(this.allComplaints);

    // Generate CSV file
    const fileName = "complaints.csv";
    this.saveCsvFile(csvData, fileName);
  }

  convertToCsv(data: any[]): string {
    // Build headers array - same order as PDF
    const headers: string[] = [];

    if (this.selectedColumns["complaintNo"]) {
      headers.push("Complaint No/شکایت نمبر");
    }
    if (this.selectedColumns["status"]) {
      headers.push("Status/حالت");
    }
    if (this.selectedColumns["cnic"] && this.canSeeInfo) {
      headers.push("CNIC/شناختی کارڈ");
    }
    if (this.selectedColumns["gender"] && this.canSeeInfo) {
      headers.push("Gender/جنس");
    }
    if (this.selectedColumns["email"] && this.canSeeInfo) {
      headers.push("Email/ای میل");
    }
    if (this.selectedColumns["complaintCategoryName"]) {
      headers.push("Complaint Type/شکایت کی قسم");
    }
    if (this.selectedColumns["complaintSubcategoryName"]) {
      headers.push("Complaint Subtype/شکایت کی ذیلی قسم");
    }
    if (this.selectedColumns["complainantName"] && this.canSeeInfo) {
      headers.push("Complainant Name/شکایت کنندہ کا نام");
    }
    if (this.selectedColumns["cellPhoneNo"] && this.canSeeInfo) {
      headers.push("Phone/فون");
    }
    if (this.selectedColumns["divisionName"]) {
      headers.push("Division/ڈویژن");
    }
    if (this.selectedColumns["districtName"]) {
      headers.push("District/ضلع");
    }
    if (this.selectedColumns["tehsilName"]) {
      headers.push("Tehsil/تحصیل");
    }
    if (this.selectedColumns["mouzaName"]) {
      headers.push("Mouza/موضع");
    }
    if (this.selectedColumns["priority"]) {
      headers.push("Priority/ترجیح");
    }
    if (this.selectedColumns["severity"]) {
      headers.push("Severity/شدت");
    }
    if (this.selectedColumns["daysRequired"]) {
      headers.push("Days Required/مطلوبہ دن");
    }
    if (this.selectedColumns["legalFramework"]) {
      headers.push("Legal Framework/قانونی ڈھانچہ");
    }
    if (this.selectedColumns["expectedResolutionDate"]) {
      headers.push("Expected Resolution Date/متوقع حل کی تاریخ");
    }
    if (this.selectedColumns["complaintAddress"]) {
      headers.push("Complaint Address/شکایت کا پتہ");
    }
    if (this.selectedColumns["description"]) {
      headers.push("Description/تفصیل");
    }
    if (this.selectedColumns["complaintSource"]) {
      headers.push("Source/ذریعہ");
    }
    if (this.selectedColumns["assignToName"]) {
      headers.push("Assign To/تفویض");
    }
    if (this.selectedColumns["assignToGroupName"]) {
      headers.push("Group Assign To/گروپ تفویض");
    }
    if (this.selectedColumns["workCode"]) {
      headers.push("Work Code/ورک کوڈ");
    }
    if (this.selectedColumns["helplineIdentifier"]) {
      headers.push("Helpline Identifier/ہیلپ لائن");
    }
    if (this.selectedColumns["passportNo"] && this.canSeeInfo) {
      headers.push("Passport No/پاسپورٹ نمبر");
    }
    if (this.selectedColumns["segmentName"]) {
      headers.push("Segment/سیگمنٹ");
    }
    if (this.selectedColumns["citizenAddress"] && this.canSeeInfo) {
      headers.push("Citizen Address/شہری کا پتہ");
    }
    if (this.selectedColumns["isAnonymous"]) {
      headers.push("Anonymous Complaint/گمنام شکایت");
    }
    if (this.selectedColumns["otherSource"]) {
      headers.push("Other Forum/دوسرا فورم");
    }

    // Build CSV with headers
    let csv = headers.join(",") + "\n";

    // Build rows - same pattern as PDF (direct property check, same order)
    data.forEach((item: any) => {
      const rowValues: string[] = [];

      if (this.selectedColumns["complaintNo"]) {
        rowValues.push(item.complaintNo || "");
      }
      if (this.selectedColumns["status"]) {
        rowValues.push(item.currentProcess?.name || "");
      }
      if (this.selectedColumns["cnic"] && this.canSeeInfo) {
        rowValues.push(item.cnic || "");
      }
      if (this.selectedColumns["gender"] && this.canSeeInfo) {
        rowValues.push(item.gender || "");
      }
      if (this.selectedColumns["email"] && this.canSeeInfo) {
        rowValues.push(item.email || "");
      }
      if (this.selectedColumns["complaintCategoryName"]) {
        const val = (item.complaintCategoryName || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["complaintSubcategoryName"]) {
        const val = (item.complaintSubcategoryName || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["complainantName"] && this.canSeeInfo) {
        const val = (item.complainantName || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["cellPhoneNo"] && this.canSeeInfo) {
        // Use Excel formula to preserve leading zeros
        rowValues.push(item.cellPhoneNo ? `= "${item.cellPhoneNo}"` : "");
      }
      if (this.selectedColumns["divisionName"]) {
        const val = (item.divisionName || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["districtName"]) {
        const val = (item.districtName || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["tehsilName"]) {
        const val = (item.tehsilName || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["mouzaName"]) {
        const val = (item.mouzaName || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["priority"]) {
        rowValues.push(item.priority || "");
      }
      if (this.selectedColumns["severity"]) {
        rowValues.push(item.severity || "");
      }
      if (this.selectedColumns["daysRequired"]) {
        rowValues.push(item.daysRequired || "");
      }
      if (this.selectedColumns["legalFramework"]) {
        const val = (item.legalFramework || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["expectedResolutionDate"]) {
        const date = item.expectedResolutionDate ? this.datePipe.transform(item.expectedResolutionDate, 'dd-MM-yyyy') : '';
        rowValues.push(date || "");
      }
      if (this.selectedColumns["complaintAddress"]) {
        const val = (item.complaintAddress || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["description"]) {
        // Strip HTML and escape for CSV
        const plainText = (item.complaintDetails || "").replace(/<[^>]*>/g, '').replace(/"/g, '""');
        rowValues.push(`"${plainText}"`);
      }
      if (this.selectedColumns["complaintSource"]) {
        rowValues.push(item.complaintSource || "");
      }
      if (this.selectedColumns["assignToName"]) {
        const val = (item.assignToName || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["assignToGroupName"]) {
        const val = (item.assignToGroupName || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["workCode"]) {
        rowValues.push(item.workCode || "");
      }
      if (this.selectedColumns["helplineIdentifier"]) {
        rowValues.push(item.helplineIdentifier || "");
      }
      if (this.selectedColumns["passportNo"] && this.canSeeInfo) {
        rowValues.push(item.passportNo || "");
      }
      if (this.selectedColumns["segmentName"]) {
        rowValues.push(item.segmentName || "");
      }
      if (this.selectedColumns["citizenAddress"] && this.canSeeInfo) {
        const val = (item.address || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }
      if (this.selectedColumns["isAnonymous"]) {
        rowValues.push(item.isAnonymous ? "Yes" : "No");
      }
      if (this.selectedColumns["otherSource"]) {
        const val = (item.otherSource || "").replace(/"/g, '""');
        rowValues.push(`"${val}"`);
      }

      csv += rowValues.join(",") + "\n";
    });

    return csv;
  }

  saveCsvFile(data: string, fileName: string) {
    const blob = new Blob([`\uFEFF${data} `], {
      type: "text/csv;charset=utf-8;",
    }); // Add BOM for UTF-8 encoding
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    // Reset pageSize to 5 after exporting
    this.pageSize = 10;
    this.form.get("pageSize")?.setValue(this.pageSize);
  }

  onRangeChange() {
    const start = this.dateRangeForm.value["dateFrom"];
    const end = this.dateRangeForm.value["dateTo"];
    const formattedStart = this.datePipe.transform(start, "yyyy-MM-dd");
    const formattedEnd = this.datePipe.transform(end, "yyyy-MM-dd");
    this.f["dateFrom"].setValue(formattedStart);
    this.f["dateTo"].setValue(formattedEnd);
  }

  clearDateRange() {
    this.dateRangeForm.reset();
  }

  formatCnic(event: any) {
    const cnicValue: string = event.target.value;
    const formattedCnic: string = cnicValue
      .replace(/[^0-9]/g, "")
      .replace(/(\d{5})(\d{7})(\d{1})/, "$1-$2-$3");
    this.form.patchValue({ cnic: formattedCnic });
  }
}
